var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-input",
    {
      directives: [{ name: "input-limit", rawName: "v-input-limit" }],
      ref: "password-input",
      staticClass: "cloud-password",
      class: { "cloud-password-padding": _vm.showEye },
      attrs: {
        value: _vm.value,
        type: _vm.inputType,
        tips: _vm.tips,
        maxlength: _vm.maxlength,
        "data-input-type": _vm.dataType,
        "tips-max-width": _vm.tipsMaxWidth,
        readonly: _vm.readonly,
        "auto-complete": _vm.autoComplete,
        placeholder: _vm.placeholder,
        "validate-event": _vm.validateEvent,
      },
      on: {
        input: function ($event) {
          return _vm.onInput($event)
        },
        blur: _vm.onBlurChangeType,
        focus: function ($event) {
          return _vm.onFocus($event)
        },
      },
      nativeOn: {
        copy: function ($event) {
          $event.preventDefault()
          return _vm.handelFlase.apply(null, arguments)
        },
        paste: function ($event) {
          $event.preventDefault()
          return _vm.handelFlase.apply(null, arguments)
        },
        cut: function ($event) {
          $event.preventDefault()
          return _vm.handelFlase.apply(null, arguments)
        },
      },
    },
    [
      _vm.showEye
        ? _c("i", {
            staticClass: "el-input__icon",
            class: _vm.iconClass,
            attrs: { slot: "suffix" },
            on: {
              mouseenter: function ($event) {
                return _vm.changeIconClick(1)
              },
              mouseleave: function ($event) {
                return _vm.changeIconClick(2)
              },
              click: function ($event) {
                return _vm.changeDisplayPassword()
              },
            },
            slot: "suffix",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }